/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import DescriptionIcon from "@material-ui/icons/Description";
import LanguageIcon from "@material-ui/icons/Language";
import ImageIcon from "@material-ui/icons/Image";
import { shallowEqual, useSelector } from "react-redux";
import { AttachMoney, Email, Watch } from "@material-ui/icons";
import { FaSpider } from "react-icons/fa6";
import { FaHashtag } from "react-icons/fa";
import { LuOmega } from "react-icons/lu";
import { HiMiniSwatch } from "react-icons/hi2";
import { RiAdvertisementFill, RiAdvertisementLine } from "react-icons/ri";
import { SiBlogger } from "react-icons/si";
import { MdCategory } from "react-icons/md";
import { TbMailDollar, TbChartLine } from "react-icons/tb";
import { MdEditNote } from "react-icons/md";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { FaShoppingBag } from "react-icons/fa";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import StarIcon from "@material-ui/icons/Star";
import { countUnreadLeats } from "../../../../../api/leat";
import { countUnreadLeatVentas } from "../../../../../api/leatVenta";
import { countPendingPedidos } from "../../../../../api/pedidos";
import { countUnreadLogsTasacion } from "../../../../../api/logTasacion";

export function AsideMenuList({ layoutProps }) {
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const location = useLocation();
  const [unreadLeatsCount, setUnreadLeatsCount] = useState(0);
  const [unreadLeatVentasCount, setUnreadLeatVentasCount] = useState(0);
  const [pendingPedidosCount, setPendingPedidosCount] = useState(0);
  const [unreadLogsTasacionCount, setUnreadLogsTasacionCount] = useState(0);

  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  // Fetch unread counts (also triggered by custom event when a page marks items as read)
  useEffect(() => {
    const fetchUnreadCounts = async () => {
      try {
        const [leatsRes, leatVentasRes, pedidosRes, logsTasacionRes] = await Promise.all([
          countUnreadLeats(),
          countUnreadLeatVentas(),
          countPendingPedidos(),
          countUnreadLogsTasacion(),
        ]);
        
        if (leatsRes?.data?.count !== undefined) {
          setUnreadLeatsCount(leatsRes.data.count);
        }
        if (leatVentasRes?.data?.count !== undefined) {
          setUnreadLeatVentasCount(leatVentasRes.data.count);
        }
        let pedidosCount = 0;
        if (pedidosRes?.data) {
          if (typeof pedidosRes.data === "number") {
            pedidosCount = pedidosRes.data;
          } else if (pedidosRes.data.count !== undefined) {
            pedidosCount = pedidosRes.data.count;
          }
        }
        setPendingPedidosCount(pedidosCount);
        if (logsTasacionRes?.data?.count !== undefined) {
          setUnreadLogsTasacionCount(logsTasacionRes.data.count);
        }
      } catch (error) {
        console.error("Error fetching unread counts:", error);
        console.error("Error details:", error.response?.data || error.message);
      }
    };

    fetchUnreadCounts();
    const onRefresh = () => fetchUnreadCounts();
    window.addEventListener("refreshUnreadCounts", onRefresh);
    const interval = setInterval(fetchUnreadCounts, 30000);
    return () => {
      window.removeEventListener("refreshUnreadCounts", onRefresh);
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/* Dashboard */}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>

        {/* Constantes */}
        {user.role === "admin" && (
          <>
            <li className="menu-section">
              <h4 className="menu-text">CONSTANTES</h4>
              <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/constants",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/constants">
                <span className="menu-icon">
                  <MonetizationOnIcon />
                </span>
                <span className="menu-text">Constantes</span>
              </NavLink>
            </li>
          </>
        )}

        {/* Tienda */}
        <li className="menu-section">
          <h4 className="menu-text">TIENDA</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/relojes", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/relojes">
            <span className="menu-icon">
              <Watch />
            </span>
            <span className="menu-text">Relojes</span>
          </NavLink>
        </li>
        {user.role === "admin" && (
          <>
            <li
              className={`menu-item ${getMenuItemActive("/bestsellers", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/bestsellers">
                <span className="menu-icon">
                  <StarIcon />
                </span>
                <span className="menu-text">Más Vendidos</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive("/cupones", false)} ${getMenuItemActive("/edit-cupon", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/cupones">
                <span className="menu-icon">
                  <LocalOfferIcon />
                </span>
                <span className="menu-text">Cupones</span>
              </NavLink>
            </li>
          </>
        )}

        {/* Ventas */}
        <li className="menu-section">
          <h4 className="menu-text">VENTAS</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/pedidos", false)}`}
          aria-haspopup="true"
          style={{ position: "relative" }}
        >
          <NavLink className="menu-link" to="/pedidos" style={{ position: "relative", overflow: "visible" }}>
            <span className="menu-icon">
              <FaShoppingBag />
            </span>
            <span className="menu-text">Pedidos</span>
          </NavLink>
          {pendingPedidosCount > 0 && (
            <span
              className="badge badge-danger"
              style={{
                position: "absolute",
                top: "50%",
                right: "12px",
                transform: "translateY(-50%)",
                minWidth: "20px",
                height: "20px",
                padding: "0 6px",
                fontSize: "11px",
                lineHeight: "20px",
                borderRadius: "10px",
                backgroundColor: "#f1416c",
                color: "#fff",
                fontWeight: "bold",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10,
                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                pointerEvents: "none",
              }}
            >
              {pendingPedidosCount > 99 ? "99+" : pendingPedidosCount}
            </span>
          )}
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/leat-ventas", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/leat-ventas" style={{ position: "relative", overflow: "visible" }}>
            <span className="menu-icon">
              <TbMailDollar />
            </span>
            <span className="menu-text">Mensajes Venta</span>
            {unreadLeatVentasCount > 0 && (
              <span
                className="badge badge-danger"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "12px",
                  transform: "translateY(-50%)",
                  minWidth: "20px",
                  height: "20px",
                  padding: "0 6px",
                  fontSize: "11px",
                  lineHeight: "20px",
                  borderRadius: "10px",
                  backgroundColor: "#f1416c",
                  color: "#fff",
                  fontWeight: "bold",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 10,
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                }}
              >
                {unreadLeatVentasCount > 99 ? "99+" : unreadLeatVentasCount}
              </span>
            )}
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/logs-tasacion", false)}`}
          aria-haspopup="true"
          style={{ position: "relative" }}
        >
          <NavLink className="menu-link" to="/logs-tasacion" style={{ position: "relative", overflow: "visible" }}>
            <span className="menu-icon">
              <TbChartLine />
            </span>
            <span className="menu-text">Logs Tasación</span>
            {unreadLogsTasacionCount > 0 && (
              <span
                className="badge badge-danger"
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "12px",
                  transform: "translateY(-50%)",
                  minWidth: "20px",
                  height: "20px",
                  padding: "0 6px",
                  fontSize: "11px",
                  lineHeight: "20px",
                  borderRadius: "10px",
                  backgroundColor: "#f1416c",
                  color: "#fff",
                  fontWeight: "bold",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 10,
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  pointerEvents: "none",
                }}
              >
                {unreadLogsTasacionCount > 99 ? "99+" : unreadLogsTasacionCount}
              </span>
            )}
          </NavLink>
        </li>

        {/* Relojes (scraping) */}
        <li className="menu-section">
          <h4 className="menu-text">RELOJES (SCRAPING)</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/marcas", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/marcas">
            <span className="menu-icon">
              <LuOmega />
            </span>
            <span className="menu-text">Marcas</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/modelos", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/modelos">
            <span className="menu-icon">
              <HiMiniSwatch />
            </span>
            <span className="menu-text">Modelos</span>
          </NavLink>
        </li>
        {user.role === "admin" && (
          <>
            <li
              className={`menu-item ${getMenuItemActive(
                "/scraping-relojes",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/scraping-relojes">
                <span className="menu-icon">
                  <FaSpider />
                </span>
                <span className="menu-text">Scraping</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive("/tasar", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/tasar">
                <span className="menu-icon">
                  <MonetizationOnIcon />
                </span>
                <span className="menu-text">Tasar</span>
              </NavLink>
            </li>
          </>
        )}

        {/* Usuarios */}
        <li className="menu-section">
          <h4 className="menu-text">USUARIOS</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        {user.role === "admin" && (
          <>
            <li
              className={`menu-item ${getMenuItemActive(
                "/admins",
                false
              )} ${getMenuItemActive("/edit-admin", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/admins">
                <span className="menu-icon">
                  <AssignmentIndIcon />
                </span>
                <span className="menu-text">Administrador</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive("/leats", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/leats" style={{ position: "relative", overflow: "visible" }}>
                <span className="menu-icon">
                  <Email />
                </span>
                <span className="menu-text">Mensajes</span>
                {unreadLeatsCount > 0 && (
                  <span
                    className="badge badge-danger"
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "12px",
                      transform: "translateY(-50%)",
                      minWidth: "20px",
                      height: "20px",
                      padding: "0 6px",
                      fontSize: "11px",
                      lineHeight: "20px",
                      borderRadius: "10px",
                      backgroundColor: "#f1416c",
                      color: "#fff",
                      fontWeight: "bold",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 10,
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                  >
                    {unreadLeatsCount > 99 ? "99+" : unreadLeatsCount}
                  </span>
                )}
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive("/campanas-promocionales", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/campanas-promocionales">
                <span className="menu-icon">
                  <MailOutlineIcon />
                </span>
                <span className="menu-text">Campañas Promocionales</span>
              </NavLink>
            </li>
          </>
        )}

        {/* Blog */}
        <li className="menu-section">
          <h4 className="menu-text">BLOG</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        {user.role === "admin" && (
          <>
            <li
              className={`menu-item ${getMenuItemActive(
                "/blogs",
                false
              )} ${getMenuItemActive("/edit-blog", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/blogs">
                <span className="menu-icon">
                  <SiBlogger />
                </span>
                <span className="menu-text">Blogs</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/tags",
                false
              )} ${getMenuItemActive("/edit-tag", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/tags">
                <span className="menu-icon">
                  <FaHashtag />
                </span>
                <span className="menu-text">Tags</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/categorias",
                false
              )} ${getMenuItemActive("/edit-categoria", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/categorias">
                <span className="menu-icon">
                  <MdCategory />
                </span>
                <span className="menu-text">Categorias</span>
              </NavLink>
            </li>
          </>
        )}

        {/* Recursos */}
        <li className="menu-section">
          <h4 className="menu-text">RECURSOS</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        {user.role === "admin" && (
          <>
            <li
              className={`menu-item ${getMenuItemActive(
                "/texts",
                false
              )} ${getMenuItemActive("/edit-text", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/texts">
                <span className="menu-icon">
                  <DescriptionIcon />
                </span>
                <span className="menu-text">Texto</span>
              </NavLink>
            </li>
            {/* Multimedia temporalmente oculto */}
            <li
              className={`menu-item ${getMenuItemActive(
                "/faqs",
                false
              )} ${getMenuItemActive("/edit-faq", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/faqs">
                <span className="menu-icon">
                  <HelpOutlineIcon />
                </span>
                <span className="menu-text">FAQs</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/reviews",
                false
              )} ${getMenuItemActive("/edit-review", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/reviews">
                <span className="menu-icon">
                  <StarIcon />
                </span>
                <span className="menu-text">Reviews</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/languages",
                false
              )} ${getMenuItemActive("/edit-language", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/languages">
                <span className="menu-icon">
                  <LanguageIcon />
                </span>
                <span className="menu-text">Idiomas</span>
              </NavLink>
            </li>
          </>
        )}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
